<template>
    <div :class="$route.meta.bodyClass">        
        <transition>
            <keep-alive>
                <router-view :key="$route.fullPath"></router-view>
            </keep-alive>
        </transition>
        <footerMain />
    </div>
</template>
<script>
import footerMain from "../../shared/commercial/Footer";

export default {
  name: "default",
  components: {
    footerMain
  },
  method: {
    closeNav() {
      alert();
    }
  }
};
</script>